// Packages
import PropTypes from 'prop-types';

// Components
import Container from 'components/BTDUI/Container';
import ScreenTitle from 'components/ScreenTitle';
import Header from 'components/Header';
import BTDButton from 'components/BTDUI/BTDButton';
import Footer from 'components/Footer';

const ContractLayout = ({ children, title }) => {

	return (
		<div className='ContractLayout'>
			
			<Header/>

			<Container>

				<ScreenTitle title={title}>
					<BTDButton
						label='Schedule'
						url='/contracts/schedule'
					/>
				</ScreenTitle>

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

ContractLayout.propTypes = {
	children: PropTypes.node,
	title: PropTypes.string
}

ContractLayout.defaultProps = {
	children: null,
	title: ''
}

export default ContractLayout;